;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const View  = APP.module('View');
	const Model = APP.module('Model');

	View.User = Marionette.ItemView.extend({
		default_page: '404',
		initialize:   function () {
			return this.listenEvt();
		},

		listenEvt: function () {
			this.listenTo(this, 'user:save_to_storage', this.saveUserToStorage);
			this.listenTo(APP.vent, 'user:save_to_storage', this.saveUserToStorage);
			// this.listenTo(this, 'user:save_to_storage:without_sid', this.saveUserWithoutSidToStorage);
			this.listenTo(APP.vent, 'user:login', this.userLogin);
			this.listenTo(APP.vent, 'user:login:pure', this.pureUserLogin);
			this.listenTo(APP.vent, 'user:logout', this.userLogout);
			this.listenTo(APP.vent, 'user:logoutSSO', this.userLogoutSSO);
			//this.listenTo(this.model, 'destroy', this.clearUserAndRedirect);
			this.listenTo(APP.vent, 'user:update', this.userUpdate);
			this.listenTo(APP.vent, 'user:register', this.userRegister);
			this.listenTo(APP.vent, 'user:register:error', this.userRegisterError);
			this.listenTo(APP.vent, 'user:register:not_completed', this.userRegisterNotCompleted);
			this.listenTo(APP.vent, 'user:get:profile', this.userUpdate);

			this.listenTo(APP.vent, 'user:get:get_extra_data', this.getProfilePromise);

			this.listenTo(APP.vent, 'user:change:default:page', this.changeDefaultPage);

			this.listenTo(this.model, 'change:id', this.setAvatarUrl);

			if (this.model.get('id')) {
				this.setAvatarUrl();
			}

			return this;
		},

		changeDefaultPage(default_page_route){
			this.default_page = default_page_route;
		},

		userLogin: function (user_data) {
			this.model.save(user_data.user);

			this.triggersOnLogin(user_data);

			if (user_data.user.recovered) {
				this.getProfilePromise(user_data);
			}
			else {
				this.redirectUserToTarget();
			}

			return this;
		},

		triggersOnLogin(user_data){
			this.trigger('user:save_to_storage', user_data);

			return this;
		},

		saveUserToStorage: function (user_data) {
			const sid = user_data['session_id'] || user_data['sessionId'];
			APP.setJStorage('session_id', sid);
			APP.setJStorage('user_id', user_data.user.id);
			this.model.save(user_data.user);
		},

		pureUserLogin: function (user_data) {

			if (user_data) {
				this.trigger('user:save_to_storage', user_data);
			}

			this.redirectUserToTarget();
		},

		userUpdate: function (user_data) {
			var avatar_url_hash = CONFIG.FRONT_PROTOCOL + CONFIG.AVATARS_URL + this.model.get('id') + '.png?hash=' + new Date().getTime();
			this.model.set('avatar_url', avatar_url_hash);
			if (user_data) {
				const user = user_data.user || user_data;
				this.model.save(user);
			}
		},

		userRegister: function (user_data) {

			this.trackRegister();

			this.model.save(user_data.user);

			this.trigger('user:save_to_storage', user_data);
			this.redirectUserToTarget();
			this.hidePreloader();
			APP.delJStorage('registrationUser');
		},

		facebookConnectResponseHandler: function (response) {

			if (response.errors && response.errors.length) {
				this.objectView.showErrors(response.errors);
				this.objectView.hidePreloader();
			}

			return this.callback ? this.callback(this.callbackData) : this.objectView;
		},

		userRegisterError: function (errors) {

			this.showErrors(errors);
			this.hidePreloader();
			APP.delJStorage('registrationUser');
		},

		userRegisterNotCompleted: function (user_data) {

			this.model.save(user_data.user);

			/*FB Connect*/
			this.trigger('user:save_to_storage', user_data);

			this.facebookConnect(user_data).done(
				this.facebookConnectResponseHandler
					.bind({
						objectView:   this,
						callback:     false,
						callbackData: false
					})
			);

			this.hidePreloader();

		},

		userGetProfile: function () {

			var avatar_url_hash = CONFIG.FRONT_PROTOCOL + CONFIG.AVATARS_URL + this.model.get('id') + '.png?hash=' + new Date().getTime();
			this.model.set('avatar_url', avatar_url_hash);
			// this.model.set(this.model);

			return this;
		},

		// TODO: Merge with userGetProfile
		setAvatarUrl: function () {

			var avatar_url_hash = CONFIG.FRONT_PROTOCOL + CONFIG.AVATARS_URL + this.model.get('id') + '.png?hash=' + new Date().getTime();
			this.model.set('avatar_url', avatar_url_hash);

			return this;
		},

		userLogout: function () {
			this.showPreloader()
				.model
				.logout()
				.done(this.clearUserAndRedirect.bind(this));

		},

		userLogoutSSO: function () {
			this.showPreloader()
				.model
				.logout()
				.done(this.clearUserAndRedirectSSO.bind(this));
		},

		clearUserAndRedirect: function () {

			APP.clearUserAndRedirectToLogin();

			return this;

		},

		clearUserAndRedirectSSO: function () {

			APP.clearUserAndRedirectToLoginSSO();

			return this;

		},

		getProfilePromise: function (data) {
			this.model.getProfile(data.user).done(this.ProfilePromiseResponse.bind(this));
		},

		ProfilePromiseResponse: function (response) {
			if (response.errors.length) {

				this.showErrors(response.errors);

				this.redirectUserToTarget();

			}
			else {
				var updated_data = _.extend(this.model.toJSON(), response.result.user);

				this.model.set(updated_data);

				APP.vent.trigger('user:get:profile');

				this.redirectUserToTarget();

			}

			this.hidePreloader();
		},

		facebookConnect: function (data) {
			var deferred = $.Deferred();

			if (data.token.length) {

				var fbConnect = new Model.FacebookConnect();
				fbConnect.set('token', data.token);

				return fbConnect.save();
			}
			else {
				return deferred.resolve(this).promise();
			}

		},

		redirectUserToTarget: function () {

			var user_desired_url = APP.getAndDeleteJStorage('backTo');

			if (user_desired_url && (user_desired_url === '#login' || user_desired_url === '#logout')) {
				user_desired_url = false;
			}

			Backbone.history.navigate(user_desired_url ? user_desired_url : (this.default_page ? this.default_page : '#'), {trigger: true});
		},

		render: function () {
			return this;
		},

		trackRegister: function() {
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));
